// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MegaDropdownList_mega-dropdown-list__header__s07YO {
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--blue-extra-dark);
  margin-bottom: 2.6rem;
}

.MegaDropdownList_mega-dropdown-list__nav-list__08BTR {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.MegaDropdownList_mega-dropdown-list__nav-item__75ptY {
  font-size: var(--text-sm);
  font-weight: 500;
  line-height: 2.2rem;
  color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Navbar/NavSuggestions/CategoriesMegaDropdown/MegaDropdownList/MegaDropdownList.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".mega-dropdown-list__header {\n  font-size: var(--text-base);\n  font-weight: 700;\n  color: var(--blue-extra-dark);\n  margin-bottom: 2.6rem;\n}\n\n.mega-dropdown-list__nav-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n\n.mega-dropdown-list__nav-item {\n  font-size: var(--text-sm);\n  font-weight: 500;\n  line-height: 2.2rem;\n  color: var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mega-dropdown-list__header": `MegaDropdownList_mega-dropdown-list__header__s07YO`,
	"mega-dropdown-list__nav-list": `MegaDropdownList_mega-dropdown-list__nav-list__08BTR`,
	"mega-dropdown-list__nav-item": `MegaDropdownList_mega-dropdown-list__nav-item__75ptY`
};
export default ___CSS_LOADER_EXPORT___;
